import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useResumeCardContext from "../ResumeCardContext";
import Card from "src/components/Card";
import Button from "src/components/Button";
import Slider from "src/components/slider/Slider";
import ReadMore from "src/components/ReadMore";
import useBackUrl from "src/hooks/useBackUrl";
import useWindowSize from "src/hooks/useWindowSize";

interface ResumeWorkProps extends Translation {
	editable?: boolean;
}

function ResumeWork({ t, editable }: ResumeWorkProps) {
	const { resume } = useResumeCardContext();
	const experiences = resume?.job_experiences || [];
	const backUrl = useBackUrl();
	const { isPhone } = useWindowSize();

	if (!resume.job_experiences.length) {
		return <></>;
	}

	return (
		<div className={`flex flex-col ${!editable && "gap-4"}`}>
			<Slider
				options={{
					slides: 3,
					gap: 12,
				}}
			>
				<div className="flex items-end justify-between mb-4">
					<h3 className="">{t("title")}</h3>
					<div className="flex items-center gap-4">
						{editable && (
							<Button
								type="none"
								iconOnly={true}
								icon="fa fa-pencil"
								to={`/profile/resume/create/work?${backUrl}`}
							/>
						)}
						{(experiences.length > 3 ||
							(isPhone && experiences.length > 1)) && (
							<div className="flex items-center gap-3 mt-1 md:mt-3">
								<Slider.Button
									direction="previous"
									iconOnly
									type="dark"
								>
									<i className="far fa-arrow-left"></i>
								</Slider.Button>
								<Slider.Button
									direction="next"
									iconOnly
									type="dark"
								>
									<i className="far fa-arrow-right"></i>
								</Slider.Button>
							</div>
						)}
					</div>
				</div>

				<Slider.Items>
					{experiences.map((item: any) => (
						<Card key={item.id}>
							<div className="flex flex-col">
								<small>{item.title}</small>
								<div className="flex mt-2 justify-between items-center">
									<h4 className="mb-0">{item.subtitle}</h4>
									<small>{`${item.started}-${
										item.ended ? item.ended : "heden"
									}`}</small>
								</div>
								{item.description && (
									<ReadMore
										className="mt-2"
										text={item.description}
										length={120}
									/>
								)}
							</div>
						</Card>
					))}
				</Slider.Items>
			</Slider>
		</div>
	);
}

ResumeWork.locale = {
	nl: {
		title: "Werkervaringen",
	},
	en: {
		title: "Work experiences",
	},
};

export default withTranslation(ResumeWork);
